import { useEffect } from "react";
import { useRouterState } from "@tanstack/react-router";

/**
 * Scrolls the inner <main> scroll container to the top on every navigation.
 *
 * Required because <main> uses `overflow-auto` (inner scroll container),
 * which means `window.scrollTo` (used by the router's built-in
 * `scrollRestoration`) never fires. This component detects pathname changes
 * and scrolls the container directly.
 */
export function ScrollToTop() {
  const pathname = useRouterState({
    select: state => state.location.pathname,
  });

  useEffect(() => {
    const main = document.querySelector("main");
    main?.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}
